import PropTypes from "prop-types";

export const GridContainer = ({ children }) => {
  return <div className="home-grid-container">{children}</div>;
};

GridContainer.propTypes = {
  children: PropTypes.node.isRequired,
};
